module.exports = function(app) {
    'use strict';

    app.directive('eprMnloa', function () {
        return {
            template: require('directives/employee/eprMnloa.html'),
            restrict: 'A',
            replace: false,

            scope: {
                editMode: '=?',
                person: '=eprMnloa'

            },

            controller: ['$scope','addFlowCommander', function ($scope, addFlowCommander) {
                $scope.commander = addFlowCommander;

				$scope.$watch('person.mnloa.startDate', function(n) {
					$scope.isCertified = Boolean(n);
				});

            }]
        };
    });
};
